/* eslint-disable eqeqeq */
import React from "react";
import PropTypes from "prop-types";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import { withStyles } from "@material-ui/styles";
import { Grid, Paper } from "@material-ui/core";
import CustomDataGrid from "../../../../components/CustomDataGrid/CustomDataGrid";
import CustomizedFileDownloader from "./CustomizedFileDownloader";

const useStyles = () => ({
  card: {
    display: "flex",
    flexDirection: "column",
    boxShadow:
      "0 4px 4px 0 rgba(0, 0, 0, 0.2), 0 2px 15px 0 rgba(0, 0, 0, 0.19)",
    borderRadius: 10,
    minHeight: 92,
    // maxHeight: 300,
  },

  itemCard: {
    display: "flex",
    flexDirection: "column",
    boxShadow:
      "0 4px 4px 0 rgba(0, 0, 0, 0.2), 0 2px 15px 0 rgba(0, 0, 0, 0.19)",
    borderRadius: 10,
    width: "98%",
    marginTop: 10,
    overflow: "visible",
    backgroundColor: "#f2f2f2",
    cursor: "pointer",
    marginBottom: 10,
  },
  title: {
    color: "#3f51b5",
    display: "flex",
    fontSize: 14,
    marginTop: 5,
    //width: "80%",
    marginLeft: 20,
  },
  itemTitle: {
    color: "#3f51b5",
    fontSize: 15,
    marginRight: 5,
    textAlign: "left",
  },
  itemSubTitle: {
    fontSize: 15,
    whiteSpace: "nowrap",
  },
  titleIcon: {
    marginRight: 20,
    fontSize: 28,
  },
  titleDivider: {
    width: "100%",
    backgroundColor: "#3f51b5",
    opacity: "0.5",
    marginLeft: 20,
  },
  itemCardTitleDivider: {
    width: "100%",
    backgroundColor: "grey",
    opacity: "0.5",
  },
  cardContent: {
    padding: 0,
    width: "100%",
    marginLeft: 10,
    marginRight: 10,
    overflow: "auto",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  itemCardContent: {
    padding: 0,
    width: "90%",
    marginLeft: 20,
    marginTop: 10,
    minHeight: 280,
    maxHeight: 280,
    display: "flex",
    flexDirection: "column",
    alignItems: "baseline",
  },

  listItem: {
    outline: "none",
    cursor: "pointer",
    paddingTop: 5,
    paddingBottom: 5,
    paddingLeft: 10,
    paddingRight: 10,
  },
  listItemContainer: {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
  },
  listItemKey: {
    fontSize: 14,
    textAlign: "left",
    fontWeight: 600,
    width: "25%",
  },
  listItemValue: {
    fontSize: 13,
    textAlign: "left",
    width: "25%",
  },
  halfWidthRight: {
    width: "50%",
    textAlign: "right",
  },
  subListItemContainer: {
    display: "flex",
    justifyContent: "space-between",
  },
  totalAmount: {
    fontSize: 14,
    display: "flex",
    justifyContent: "flex-end",
    width: "100%",
    marginRight: 10,
  },
  barcodeImage: {
    display: "flex",
    width: "100%",
    justifyContent: "end",
  },
  circularProgressStyle: {
    marginTop: 10,
  },
  itemCardContentTitle: {
    fontSize: 14,
    fontWeight: 700,
    textDecoration: "underline",
  },
  itemCardItemTitle: {
    fontSize: 14,
    fontWeight: 700,
    textAlign: "left",
    marginTop: 10,
    marginBottom: 10,
  },
  listItemActive: {
    backgroundColor: "#ffdddd !important",
  },
  headerblack: {
    color: "red",
  },
  headerblue: {
    color: "blue",
  },
  input1: {
    height: 15,
    width: "70%",
  },
});

class SalesTab extends React.Component {
  textFieldRef = null;
  constructor(props) {
    super(props);
    this.state = {
      columns: [
        { name: "name", title: "Name" },
        { name: "traybarcode", title: "Tray Barcode" },
        { name: "copies", title: "Copies" },
        { name: "size", title: "Size" },
        { name: "paperQuality", title: "Paper Quality" },
        { name: "lamination", title: "Lamination" },
        // { name: "action", title: "Action" },
        // { name: "action", title: "Action" }
      ], // Adjust the offset value as needed
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.columns !== prevProps.columns) {
      this.setState({
        columns: this.props.columns,
      });
    }

    // if (this.props.values.filterStatus == 13) {

    //   setTimeout(() => {
    //     this.textFieldRef.focus();
    //   }, 1000);
    // }
  }

  render() {
    const { classes } = this.props;

    return (
      <React.Fragment>
        <Card className={classes.card}>
          <CardContent style={{ padding: 0 }}>
            <CustomDataGrid
              columns={this.state.columns}
              rows={this.props.rows}
            />
            {/* <>{this.props.values.filterStatus==1 && */}
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="baseline"
              spacing={1}
              style={{ marginBottom: 8 }}
            >
              <Grid item xs={2}>
                <Paper
                  className={classes.paper}
                  style={{
                    marginTop: 8,
                    padding: 5,
                    marginLeft: 10,
                  }}
                >
                  {/* <Button
                    onClick={() => this.props.downloadImagesData()}
                    disabled={
                      this.props.values.imagesDataLoading ||
                      this.props.values.isDownloadImages ||
                      IsEmpty(this.props.values.selectedSalesData)
                    }
                    fullWidth
                    style={{
                      // textDecoration: "underline",
                      fontSize: 13,
                      padding: 5,
                      textTransform: "capitalize",
                      cursor: `${
                        this.props.values.isDownloadImages
                          ? "waiting"
                          : "pointer"
                      }`,
                    }}
                    color="primary"
                  >
                    {this.props.values.isDownloadImages ? (
                      <CircularProgress size={16} />
                    ) : this.props.values.filterStatus == 1 ? (
                      "Download jpg"
                    ) : (
                      "Re-Download"
                    )}
                  </Button> */}
                  <CustomizedFileDownloader
                    values={this.props.values}
                    url={`${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/sales/C05SalesOrderItemsImagesDownloadV2?orderId=${this.props.values.selectedSalesData.orderId}&productId=${this.props.values.selectedSalesData.productId}`}
                    fileName={`${this.props.values.selectedSalesData.orderId}-${this.props.values.selectedSalesData.id}-${this.props.values.selectedSalesData.name}.zip`}
                    isForceCancel={this.props.values.isForceCancel}
                    // eslint-disable-next-line react/prop-types
                    onDownloadComplete={() => this.props.onDownloadComplete()}
                  />
                </Paper>
              </Grid>

              {/* <Grid item xs={2}>
                  <Paper className={classes.paper} style={{
                             marginTop: 8,
                             padding: 5,
                             marginLeft:10
                             
                           }}>
                       <Button
                        fullWidth
                         onClick={() => this.props.downloadPdfImagesData()}
                         disabled={
                           this.props.values.imagesDataLoading ||
                           this.props.values.isDownloadPdfImages ||
                           IsEmpty(this.props.values.selectedSalesData)
                         }
                         style={{
                          
                           fontSize: 13,
                           padding: 5,
                           textTransform: "capitalize",
                           cursor: `${this.props.values.isDownloadPdfImages
                             ? "waiting"
                             : "pointer"
                             }`,
                         }}
                         color="primary"
                       >
                         {this.props.values.isDownloadPdfImages ? (
                           <CircularProgress size={16} />
                         ) : (
                           "Download Pdf"
                         )}
                       </Button>
                   </Paper>
                 </Grid>     */}
            </Grid>
            {/* }</> */}
          </CardContent>
        </Card>
      </React.Fragment>
    );
  }
}

SalesTab.propTypes = {
  classes: PropTypes.object.isRequired,
  values: PropTypes.object,
  getImagesOrderIdAndProduct: PropTypes.func,
  columns: PropTypes.array,
  rows: PropTypes.array,
  printBarcode: PropTypes.func,
};

SalesTab.defaultProps = {
  values: {},
  getImagesOrderIdAndProduct: (fn) => fn,
  columns: [],
  rows: [],
  printBarcode: (fn) => fn,
};

export default withStyles(useStyles)(SalesTab);
